import { getUserConfiguration } from 'owa-session-store';
import {
    setShowPreviewLinesOptionMutator,
    setTempPreviewLinesOptionMutator,
} from '../actions/setShowPreviewLinesOption';
import getShowPreviewLinesInListViewOCSSetting from './getShowPreviewLinesInListViewOCSSetting';
import { isSingleLineListView } from 'owa-mail-layout';
import store from '../store/store';

let loadShowPreviewLinesInListView: Promise<void> | undefined;
export default function initializeShowPreviewLinesInListViewSetting(): Promise<void> {
    const messagePreviewStore = store();
    if (messagePreviewStore.showPreviewLinesInListView !== null) {
        if (messagePreviewStore.tempPreviewLinesInListView === null) {
            Promise.resolve().then(() => {
                if (store().tempPreviewLinesInListView === null) {
                    setTempPreviewLinesOptionMutator(store().showPreviewLinesInListView);
                }
            });
        }
        return Promise.resolve();
    }

    if (!loadShowPreviewLinesInListView) {
        loadShowPreviewLinesInListView = (async () => {
            const showPreviewLinesOption = await getShowPreviewLinesInListViewOCSSetting();
            if (showPreviewLinesOption === null) {
                setShowPreviewLinesOptionMutator(getPreviewLinesFromPreviewTextFlag());
            } else {
                setShowPreviewLinesOptionMutator(showPreviewLinesOption);
            }

            if (messagePreviewStore.tempPreviewLinesInListView === null) {
                setTempPreviewLinesOptionMutator(messagePreviewStore.showPreviewLinesInListView);
            }
        })().finally(() => {
            loadShowPreviewLinesInListView = undefined;
        });
    }
    return loadShowPreviewLinesInListView;
}

function getPreviewLinesFromPreviewTextFlag(): number {
    const userConfig = getUserConfiguration();
    const previewTextToNumber = userConfig?.UserOptions?.ShowPreviewTextInListView ? 1 : 0;
    // convert for MCL and SCL
    return isSingleLineListView() && previewTextToNumber === 1 ? 0 : previewTextToNumber;
}
